import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://cms-swift-fox.herokuapp.com'
})

export default instance
